import { Link } from "react-router-dom";

interface Props {
  eyebrow?: string;
  title: string;
  desc?: string;
  link?: { label: string; to: string };
  light?: boolean;
}

export default function SectionHeading({ eyebrow, title, desc, link, light }: Props) {
  return (
    <div className="mb-7 flex flex-col gap-3 md:mb-9 md:flex-row md:items-end md:justify-between">
      <div>
        {eyebrow && (
          <p className={`mb-2 text-xs font-bold uppercase tracking-widest ${light ? "text-primary-300" : "text-primary-500"}`}>
            {eyebrow}
          </p>
        )}
        <h2 className={`font-display text-2xl md:text-3xl ${light ? "text-background-50" : "text-foreground-950"}`}>
          {title}
        </h2>
        {desc && (
          <p className={`mt-2 max-w-xl text-sm leading-6 ${light ? "text-background-200" : "text-foreground-600"}`}>
            {desc}
          </p>
        )}
      </div>
      {link && (
        <Link
          to={link.to}
          className="group flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium transition-colors"
        >
          <span className={light ? "text-background-100" : "text-foreground-700"}>{link.label}</span>
          <i className={`ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5 ${light ? "text-background-100" : "text-primary-500"}`}></i>
        </Link>
      )}
    </div>
  );
}